import {
  GET_SALE_ITEM_REQUEST,
  GET_SALE_ITEM_SUCCESS,
  GET_SALE_ITEM_FAIL
} from '../constants/saleConstants'

import {
  GENERATE_RECEIPT_REQUEST,
  GENERATE_RECEIPT_SUCCESS,
  GENERATE_RECEIPT_FAILED,
  GENERATE_RECEIPT_RESET,
  RETURNS_REQUEST,
  RETURNS_SUCCESS,
  RETURNS_FAILED,
  RETURNS_RESET
} from '../constants/posConstants'

export const saleListReducer = (state = { sales: [] }, action) => {
  switch (action.type) {
    case GET_SALE_ITEM_REQUEST:
      return { ...state, loading: true }

    case GET_SALE_ITEM_SUCCESS:
      return {
        loading: false,
        error: false,
        sales: action.payload.sales,
        pagespos: action.payload.pagespos,
        pagepos: action.payload.pagepos,
        countpos: action.payload.countpos
      }
    case GET_SALE_ITEM_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const saleListresetReducer = (state = { sales: [] }, action) => {
  switch (action.type) {
    case 'SALE_LIST_RESET':
      return { sales: [] }

    default:
      return state
  }
}

export const generateReceiptReducer = (state = {}, action) => {
  switch (action.type) {
    case GENERATE_RECEIPT_REQUEST:
      return { loading: true }
    case GENERATE_RECEIPT_SUCCESS:
      return { loading: false, success: true, genreceipt: action.payload }
    case GENERATE_RECEIPT_FAILED:
      return { loading: false, error: action.payload }
    case GENERATE_RECEIPT_RESET:
      return {}
    default:
      return state
  }
}

export const returnsReceiptReducer = (
  state = { returnreceipt: {} },
  action
) => {
  switch (action.type) {
    case RETURNS_REQUEST:
      return { ...state, loading: true }

    case RETURNS_SUCCESS:
      return {
        loading: false,
        success: true,
        returnreceipt: action.payload.returnreceipt,
        returncount: action.payload.returncount
      }

    case RETURNS_FAILED:
      return { loading: false, error: action.payload }

    case RETURNS_RESET:
      return {}

    default:
      return state
  }
}

export const returnedUpdateReducer = (state = { returninfo: {} }, action) => {
  switch (action.type) {
    case 'RETURNS_UPDATE_REQUEST':
      return { loading: true }
    case 'RETURNS_UPDATE_SUCCESS':
      return {
        loading: false,
        successupdate: true,
        returnedreceipt: action.payload
      }
    case 'RETURNS_UPDATE_FAILED':
      return { loading: false, error: action.payload }
    case 'RETURNS_UPDATE_RESET':
      return {}
    default:
      return state
  }
}
